<template>
  <div class="input input--years-months">
    <p class="input__question">
      <slot name="question"></slot>
      <i class="fas fa-asterisk" v-if="required"></i>
    </p>

    <small class="text-muted input__description" v-if="$slots.description">
      <slot name="description"></slot>
    </small>

    <fieldset class="input__controls">
      <div class="form-group d-inline-block">
        <label class="form-label">Years</label>
        <input
          type="number"
          min="0"
          :name="name"
          class="form-control"
          step="1"
          v-model="years"
          :aria-label="required && alternative_option ? aria_label : null"
          :required="required"
        />
      </div>
      <div class="form-group d-inline-block ms-sm-4">
        <label class="form-label">Months</label>
        <input
          type="number"
          min="0"
          class="form-control"
          step="1"
          v-model="months"
          :required="required"
        />
      </div>
    </fieldset>

    <slot name="input"></slot>

    <p class="form-error" v-if="error" v-text="error" role="alert" aria-live="assertive"></p>

    <div  v-if="Array.isArray(error)">
        <p class="form-error" v-for="err in error" :key="err" v-text="err" role="alert" aria-live="assertive"></p>
    </div>
  </div>
</template>


<script setup>
const months = defineModel('months')
const years = defineModel('years')

const props = defineProps({
  name: String,
  error: Array | String,
  required: Boolean,
  alternative_option: Boolean,
  aria_label: String
})
</script>
